import { TMasterSpecificActivityOccupation } from "@/api/entities/master-specific-activity-occupation.entity";
import { setHiddenSpecificActivityOccupationApi } from "@/api/services/global/master";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Dispatch, FC, SetStateAction } from "react";

type THiddenSpecificActivityOccupationModalProps = {
  hiddenSpecificActivityOccupation?: TMasterSpecificActivityOccupation;
  setHiddenSpecificActivityOccupation: Dispatch<SetStateAction<TMasterSpecificActivityOccupation | undefined>>;
};

export const HiddenSpecificActivityOccupationModal: FC<THiddenSpecificActivityOccupationModalProps> = ({
  hiddenSpecificActivityOccupation,
  setHiddenSpecificActivityOccupation,
}) => {
  const queryClient = useQueryClient();

  const handleSubmit = async () => {
    if (!hiddenSpecificActivityOccupation) return;
    try {
      await setHiddenSpecificActivityOccupationApi(toNumber(hiddenSpecificActivityOccupation.id), {
        isHidden: !hiddenSpecificActivityOccupation.isHidden,
      });
      toast.success(API_SUCCESS_MESSAGE);
      setHiddenSpecificActivityOccupation(undefined);
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_SPECIFIC_ACTIVITY_OCCUPATION] });
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Modal
      title={hiddenSpecificActivityOccupation?.isHidden ? "有効化の確認" : "無効化の確認"}
      isOpen={!!hiddenSpecificActivityOccupation}
      onClose={() => setHiddenSpecificActivityOccupation(undefined)}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      onOk={() => handleSubmit()}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {hiddenSpecificActivityOccupation?.isHidden ? "この行が有効化されますが、よろしいですか。" : "この行が無効化されますが、よろしいですか。"}
      </Typography>
    </Modal>
  );
};
